module.exports = __webpack_public_path__ + "img/A2M7_new.f396882d.jpg";